module.exports = "/_next/static/images/KCDMumbai-e81782e9d9bb24e7876e06ee06bbc994.jpg";